import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=77cae0c8"
import script from "./DoctorCard.vue?vue&type=script&lang=js"
export * from "./DoctorCard.vue?vue&type=script&lang=js"
import style0 from "./DoctorCard.vue?vue&type=style&index=0&id=77cae0c8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports